export default "__VITE_ASSET__CaHTcld4__"